import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-analytics-home',
  templateUrl: './analytics-home.component.html',
  styleUrls: ['./analytics-home.component.css'],
  imports: []
})
export class AnalyticsHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
